import { SetFile } from '@bechtel/client-common';
import { CommodityMilestone } from '@bechtel/types';

export interface CreateSingleBlockProps {
  milestones: {
    [key: string]: FormikMilestoneIdGroup[];
  };
  selectedMilestone?: CommodityMilestone;
  onSetFiles?: (setFiles: SetFile) => void;
  showMilestonesList?: boolean;
}
export interface FormikMilestoneIdGroup {
  id: CommodityMilestone['id'];
  name: CommodityMilestone['name'];
}
